import { Injectable } from '@angular/core';
import { retry, Subject, timeout } from 'rxjs';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';
import { ProjectDataRepository } from '../../../core/data/repositories/projectdata.repository';
import { ProjectCost } from '../model/project-cost';
import { ProjectInformation } from '../model/project-information';
import { ProjectDetails } from '../model/project-details';
import { ConstructionElement } from '../../../shared/model/construction-element';
import { DownloadDoc } from '../../../shared/model/sharepoint-document';
import { ProjectApprovalDTO, ProjectApproveDTO } from '../model/project-approval';
import { PROJECTSTATUS } from '../../../core/common/constant/enums';
import { ProjectFilterDTO } from '../model/project-filter';
import { ProjectComment } from '../model/project-comments';
import { ProjectModifications } from '../model/project-modifications';

@Injectable()
export class ProjectService {
  projectInformation: ProjectInformation = {
    pDetails: {} as ProjectDetails,
    pElement: [],
    pCost: [],
    pDocuments: [],
    pDocumentApproval: {},
    pValidation: {},
    test: {},
    projectId: 0,
    isEdit: true,
  };

  private projectComplete = new Subject<any>();
  projectComplete$ = this.projectComplete.asObservable();
  collapseSidebar: boolean = false;

  constructor(
    private masterDataRepository: MasterDataRepository,
    private projectDataRepository: ProjectDataRepository
  ) { }

  getProjectInformation(id: number) {
    return new Promise((resolve, reject) => {
      if (id > 0) {
        this.projectDataRepository
          .getProjectDetails(id)
          .subscribe(
            (x: any) => {
              this.projectInformation.pDetails = x.value;
              this.projectInformation.pDetails.canUserEdit = x.bag.canEdit;
              this.projectInformation.pDetails.isUserMaster = x.bag.isAdminMaster;
               this.projectInformation.pDetails.ResetValidation = x.bag.ResetValidation;
              this.projectInformation.pDetails.canUserApporved = (x.value.projectStatusID == PROJECTSTATUS.ENQUIRE ? x.bag.canApprove : x.bag.canRequestApproval);
              this.projectInformation.pDetails.canAddTest = x.bag.canAddTest;
              this.projectInformation.pDetails.canAddCertificate = x.bag.canAddCertificate;
              this.projectInformation.projectId = id;
              this.projectInformation.pDetails.projectApprovalHistory = x.bag.projectApprovalHistory;
              return resolve(this.projectInformation);
            },
            (error) => reject(error)
          );
      } else {
        return resolve(this.projectInformation);
      }
    });
  }
  //try to set data tabwise
  setProjectInformation(
    pInformation: ProjectInformation,
    reset: boolean = false
  ) {
    if (reset)
      this.projectInformation = {
        pDetails: {} as ProjectDetails,
        pElement: [],
        pCost: [],
        pDocuments: [],
        pDocumentApproval: {},
        pValidation: {},
        test: {},
        projectId: 0,
        isEdit: true,
      };
    else this.projectInformation = pInformation;
  }

  //#region Master data call

  getWorkGroups(id: number) {
    return this.masterDataRepository.getWorkGrpByOU(id);
  }
  getOwnerTypes() {
    return this.masterDataRepository.getOwnerTypes();
  }
  getPrjStatus() {
    return this.masterDataRepository.getPrjStatus();
  }
  GetAllCountryRegion() {
   return this.masterDataRepository.GetAllCountryRegion();
  }
  // getFrameMaterials() {
  //   return this.masterDataRepository.getFrameMaterials();
  // }
  // getFrameSysSuppliers() {
  //   return this.masterDataRepository.getFrameSysSuppliers();
  // }
  // getFrameNames() {
  //   return this.masterDataRepository.getFrameNames();
  // }
  // getFrameBeadPos() {
  //   return this.masterDataRepository.getFrameBeadPos();
  // }
  // getGlassTypes() {
  //   return this.masterDataRepository.getGlassTypes();
  // }
  // getGlassUnits() {
  //   return this.masterDataRepository.getGlassUnits();
  // }
  // getGlassCoatingCodes() {
  //   return this.masterDataRepository.getGlassCoatingCodes();
  // }
  // getGlassManufacturers() {
  //   return this.masterDataRepository.getGlassManufacturers();
  // }
  // getCEMountingDirection() {
  //   return this.masterDataRepository.getCEMountingDirection();
  // }
  // getCEAngle() {
  //   return this.masterDataRepository.getCEAngle();
  // }
  // getCEType() {
  //   return this.masterDataRepository.getCEType();
  // }
  getPartner() {
    return this.masterDataRepository.getPartner();
  }
  getOrganisationalUnits() {
    return this.masterDataRepository.getOrganisationalUnits();
  }
  getMyOrganisationalUnits() {
    return this.masterDataRepository.getMyOrganisationalUnits();
  }
  getPurpose() {
    return this.masterDataRepository.getPurpose();
  }
  getProjects() {
    return this.masterDataRepository.getProjects();
  }
  getCountryAndRegions() {
    return this.masterDataRepository.getCountryAndRegions();
  }
  getWorkgroup() {
    return this.masterDataRepository.getWorkgroup();
  }
  getConfidentiality() {
    return this.masterDataRepository.getConfidentiality();
  }
  getGroupview() {
    return this.masterDataRepository.getGroupview();
  }

  getCostItemType() {
    return this.masterDataRepository.getCostItemTypes();
  }
  getProjectCost() {
    return this.masterDataRepository.getProjectCost();
  }
  getUsersbyGroup(grp: number) {
    let orgunit = this.projectInformation.pDetails.organisationalUnitId;
    return this.masterDataRepository.getUserByGroup(grp, 0);
  }

  //#endregion


  //#region CRUD project
  setProjectDetails(data: ProjectDetails): any {
    return this.projectDataRepository.saveProjectDetails(data);
    //return id;
  }
  getProjectDetails(id: number) {
    return this.projectDataRepository.getProjectDetails(id);
  }
  getAllDashboardProject(query) {
    //return this.projectDataRepository.getProjectDashboardDetails();
    return this.projectDataRepository.getProjectDashboardDetails(query);      
  }

  getAllProjectNumberList(){
    return this.masterDataRepository.getProjectNumberList();
  }

  getProjectOverView(id: number) {
    return this.projectDataRepository.getOvewView(id);
  }

  getTestCertTracking(id: number) {
    return this.projectDataRepository.getTestCertTracking(id);
  }

  deleteProject(projectId: number) {
    return this.projectDataRepository.deleteProject(projectId); 
  }

  //#endregion


  //#region CRUD cost
  setEstimatedCost(data: ProjectCost[]): any {
    let result: boolean = false;
    this.projectDataRepository.saveProjectEstimatedCost(data).subscribe(
      (result: ProjectCost[]) => {
        this.projectInformation.pCost = result;
        //this.projectInformation.projectId = result.id;
      },
      (error) => {
        console.log(error);
      }
    );
    return result;
  }

  saveProjectCost(data: ProjectCost) {
    return this.projectDataRepository.saveProjectCost(data);
  }
  getProjectEstimatedCost(pId: number) {
    return this.projectDataRepository.getProjectEstimatedCost(pId);
  }
  deleteCost(projectId: number, ids: number[]): any {
    return this.projectDataRepository.deleteProjectEstimatedCost(projectId, ids);
  }
  //#endregion cost

  saveComments(comment: ProjectComment){
    return this.projectDataRepository.saveComment(comment);
  }

  saveModifications(modifications: ProjectModifications){
    return this.projectDataRepository.saveModifications(modifications);
  }

  deleteComments(id: number, projectId: number){
    return this.projectDataRepository.deleteComment(id, projectId);
  }

  getProjectComments(pId: number) {
    return this.projectDataRepository.getProjectComments(pId);
  }

  getProjectModifications(pId: number) {
    return this.projectDataRepository.getProjectModifications(pId);
  }

  //#region document
  getProjectDocument(pId: number) {
    return this.projectDataRepository.getProjectEstimatedCost(0);
  }
  setProjectDocuments(data: any[]): any {
    let result: boolean = false;
    //data.pId = this.projectInformation.projectId;
    data.forEach((value) => {
      value.pId = this.projectInformation.projectId;
    });
    this.projectDataRepository.saveProjectDocuments(data).subscribe(
      (result) => {
        // this.projectInformation.pElement = result;
        return result;
        //this.projectInformation.projectId = result.id;
      },
      (error) => {
        console.log(error);
      }
    );
    return result;
  }
  //#endregion document


  //#region validation
  getProjectValidationDetails(pId: number) {
    return this.projectDataRepository.getProjectEstimatedCost(0);
  }
  setProjectValidation(data: any): any {
    let result: boolean = false;
    data.pId = this.projectInformation.projectId;
    this.projectDataRepository.saveProjectValidators(data).subscribe(
      (result) => {
        this.projectInformation.pValidation = result;
        //this.projectInformation.projectId = result.id;
      },
      (error) => {
        console.log(error);
      }
    );
    return result;
  }

  //#endregion validation


  getAllTest(pId: number) {
    return this.projectDataRepository.getAllTest(pId);
  }

  getAllCertificate(projectId: number) {
    return this.projectDataRepository.getAllCertificate(projectId);
  }

  getAllTestElement(projectId: number) {
    return this.projectDataRepository.getAllTestElement(projectId);
  }

  getAllCertificateElement(projectId: number) {
    return this.projectDataRepository.getAllCerElement(projectId);
  }

  setProjectConstructionElements(data: ConstructionElement[]) {
    let projectElement: ConstructionElement[] = [];
    data.forEach((value: any) => {
      value.projectId = this.projectInformation.projectId;
      this.projectDataRepository.saveProjectElement(value).subscribe({
        next: (result: ConstructionElement) => {
          projectElement.push(result);
          return result;
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => {
          console.info('complete');
        },
      });
      this.projectInformation.pElement = projectElement;
    });
  }

  getApproverUsers(groupId: any, projectId: number) {
    return this.projectDataRepository.getApproverUsers(groupId, projectId);
  }

  saveApproverDetails(projectApprover: ProjectApproveDTO[], projectId: number) {
    return this.projectDataRepository.saveApproverDetails(projectApprover, projectId);
  }

  getProjectApproverDetails(projectId: number) {
    return this.projectDataRepository.getProjectApproverDetails(projectId);
  }

  validateProject(projectApprover: ProjectApproveDTO[], projectId: number) {
    return this.projectDataRepository.validateProject(projectApprover, projectId);
  }

  saveProjectNumber(projectId: number, projectNumber: string) {
    return this.projectDataRepository.saveProjectNumber(projectId, projectNumber);
  }

  closeProject(projectId: number) {
    return this.projectDataRepository.closeProject(projectId);
  }

  getApprovalGroups(organisationalUnitId: number) {
    return this.projectDataRepository.getApprovalGroups(organisationalUnitId);
  }

  getSelectedReadGroups(organisationalUnitId: number, confidentialityLvlId: number) {
    let lstReadGrp: any;
    return new Promise<any>((resolve) => {
      this.projectDataRepository.getSelectedReadGroups(organisationalUnitId, confidentialityLvlId)
        .subscribe((data: any) => {
          lstReadGrp = data;
          resolve(lstReadGrp);
        });
    });
  }

  getSearch(data: ProjectFilterDTO) {
    return this.projectDataRepository.search(data);
  }

  getExportSearch(data: ProjectFilterDTO) {
      return this.projectDataRepository.export(data);
    }
  
  resetProjectValidation(projectId: number){
     return this.projectDataRepository.resetProjectValidation(projectId);
  }
  //#region GetterSetter

  public get collapseSideBar(){
    return this.collapseSideBar;
  }

  public set collapseSideBar(value: boolean){
    this.collapseSideBar = value;
  }

  //#endregion

  addToFavorites(projectId: number) {
    return this.projectDataRepository.addToFavorites(projectId);
  }

  removeFromFavorites(projectId: number) {
    return this.projectDataRepository.removeFromFavorites(projectId);
  }




  
}
